module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f1",
    attrs: {
      "id": "preface"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Indeed, reader, here it is: a comprehensive Christmas cookbook by Van Boven! Most of the questions you sent me are about hosting dinner parties. How to plan them. What to cook when you’re having more than four guests. How much can be prepared in advance in order to avoid losing control during the evening. How to prevent a total panic attack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout the years, I’ve written tons of winter holiday recipes and stress-prevention tips for all sorts of magazines and newspapers. Therefore I figured it would be a good idea to bundle them together into a book, providing you with an easy-to-use overview.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was when composing "), _c('em', [_vm._v("Home Sweet Home")]), _vm._v(", my book on Irish comfort food, that I discovered just how many holiday recipes I had written. The Irish and I are avid celebrators, after all, of Christmas and other occasions. And just like that, my chapter on Christmas grew into a whole separate book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this Christmas book I will guide you through the winter holidays. I will give you tips on how to prevent things from getting out of hand and how to avoid panicking. I will give you easy, foolproof recipes that can be prepared ahead of time so that you too can be merry while hosting your dinner. Whenever possible the recipe directions are divided into pre-preparation and preparation parts, so you know in advance what you’re up against. Often all that is needed before serving is some reheating or the sophisticated placement of a sprig of parsley. You can do this. I will even throw in a stack of menus so you don’t have to worry about those, either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps you will be celebrating your first romantic Christmas with the love of your life. Maybe you are hosting your in-laws, with all your cousins, nephews, and nieces in tow. Whatever your situation, we will come up with a workable plan, making sure you have everything you need to pull this off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And . . . if you don’t celebrate Christmas but simply feel like having a cozy winter dinner, this book will come in very handy as well.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Be merry,")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('strong', [_vm._v("X YVETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0009-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769c4412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 78
// module chunks = 0